export const convertUrlsToLinks = (text: string) => {
  const urlRegex =
    /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
  const newLineRegex = /\n/gi;
  return text
    .replace(
      urlRegex,
      (url) =>
        `<a href="${url}" style="text-decoration: underline;" target="_blank" rel="noopener noreferrer">${url}</a>`
    )
    .replace(newLineRegex, () => `<br>`);
};
